// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/learning/OutcomeHistoryCard.jsx

import React from "react";

const outcomeRows = (outcomes) => {
  if (Array.isArray(outcomes?.outcomes)) return outcomes.outcomes;
  return [];
};

const clean = (value, fallback = "—") => {
  const text = String(value ?? "").trim();
  return text || fallback;
};

const boolLabel = (value, trueLabel = "Yes", falseLabel = "No") => (
  value ? trueLabel : falseLabel
);

function completedCount(previousOutcomes, rows) {
  const providedCount = Number(previousOutcomes?.completed_count);
  if (Number.isFinite(providedCount)) return Math.max(0, providedCount);
  return rows.length;
}

export default function OutcomeHistoryCard({ previousOutcomes = {} }) {
  const rows = outcomeRows(previousOutcomes);
  const completed = completedCount(previousOutcomes, rows);
  const completedClassName = completed > 0
    ? "learning-status-pill learning-status-pill-active"
    : "learning-status-pill";

  return (
    <section className="learning-card outcome-history-card">
      <div className="learning-card-header">
        <div>
          <p className="learning-eyebrow">Outcome Tracking</p>
          <h4>Outcome History</h4>
        </div>
        <span className={completedClassName}>
          {completed} completed
        </span>
      </div>

      {rows.length > 0 ? (
        <div className="learning-outcome-grid">
          {rows.map((row, index) => (
            <div className="learning-outcome-card" key={`${row.connector || "connector"}-${index}`}>
              <strong>{clean(row.connector, "Unknown connector")}</strong>
              <div className="learning-outcome-metrics">
                <div>
                  <span>Validated</span>
                  <b>{boolLabel(row.validated)}</b>
                </div>
                <div>
                  <span>Rollback</span>
                  <b>{row.rollback_required ? "Required" : "None"}</b>
                </div>
                <div>
                  <span>Avg time</span>
                  <b>{row.average_completion_minutes ?? "—"}m</b>
                </div>
                <div>
                  <span>Evidence</span>
                  <b>{clean(row.evidence_quality)}</b>
                </div>
                <div>
                  <span>Effort</span>
                  <b>{clean(row.estimated_vs_actual_effort).replace(/_/g, " ")}</b>
                </div>
                <div>
                  <span>Health</span>
                  <b>{clean(row.connector_health_at_execution).replace(/_/g, " ")}</b>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="learning-muted-copy">No outcome history is available for this task yet.</p>
      )}
    </section>
  );
}
